import { combineReducers } from 'redux'
import { connectRouter } from 'connected-react-router'

import apiRTKQ from './apiRTKQ'
import app from './modules/app/slice'
import auth from './modules/auth/slice'
import buyer from './modules/buyer/slice'
import messages from './modules/messages/slice'
import supplier from './modules/supplier/slice'
import notification from './modules/notification/slice'

const createRootReducer = history =>
  combineReducers({
    router: connectRouter(history),
    app,
    auth,
    buyer,
    messages,
    supplier,
    notification,
    [apiRTKQ.reducerPath]: apiRTKQ.reducer,
  })

export default createRootReducer
